<app-authentication-container>
  <div *ngIf="errored" class="button-container" fxLayout="row" fxLayoutAlign="space-between">
    <button type="submit" mat-flat-button (click)="goBack()" [disabled]="isLoading">Go back</button>
    <button type="submit" mat-flat-button (click)="logOut()" [disabled]="isLoading">Try again</button>
  </div>
</app-authentication-container>
